import React, { useState, useContext } from 'react';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import {
	Button,
	InputLabel,
	RadioGroup,
	FormControlLabel,
	Radio,
	Box,
	useMediaQuery
} from '@material-ui/core';
import {
	DELETE_DIALOG_ONCE,
	DELETE_DIALOG_ALL,
	DELETE,
	CANCEL_BUTTON,
	DELETE_SUB_HEADING,
	ONLY_REPORT,
	ALL_REPORT,
	DELETE_ONCE_COMPLETED,
	COMPLETED,
	NO_DATA_FOUND,
	SCHEDULED,
	INACTIVE,
	FAILED,
	NOW,
	LATER,
	TODAY
} from 'constants/constant';
import styles from './DeleteDialog.style';
import { useDispatch } from 'react-redux';
import { deleteReport } from '../Dashboard.actions';
import { UserPortalContext } from 'context/appcontext';
import { trackEventInfo } from 'helper/analytics';
import { EVENTS, PAGE_ID, ACTION_ON } from 'constants/tracker';

function DeleteDialog(props) {
	const dispatch = useDispatch();
	const isSmallScreen = useMediaQuery('(max-width:600px)');
	const portalUserContext = useContext(UserPortalContext);
	const { userDetails } = portalUserContext;
	const { companyName } = userDetails?.result;
	const { open, onClose, selectedRow } = props;
	const [deleteType, setDeleteType] = useState(undefined);
	const classes = styles();
	const handleCancel = (e) => {
		e.stopPropagation();
		onClose();
		setDeleteType(undefined);
	};

	const deleteOptions = [ONLY_REPORT, ALL_REPORT];
	const deleteOption = [ALL_REPORT];

	const handleDelete = () => {
		trackEventInfo({
			type: EVENTS.CLICK,
			actionOn: ACTION_ON.DELETE_REPORT_BUTTON,
			location: PAGE_ID.DASHBOARD
		});

		const requestBody = {
			reportId: selectedRow.reportId,
			deleteType: deleteType === ONLY_REPORT ? 'INSTANCE' : 'ALL_SCHEDULE'
		};
		dispatch(deleteReport({ requestBody, companyName }));
		setDeleteType(undefined);
		onClose();
	};

	const handleDeleteType = (e) => {
		setDeleteType(e.target.value);
	};

	const isOnceComplete =
		[NOW, LATER, TODAY].includes(selectedRow?.frequency) && selectedRow?.status === COMPLETED;

	const renderDeleteOptions = (item) => {
		return (
			<>
				<DialogTitle className={classes.tittlePadding}>
					<InputLabel className={classes.dialogTitle}>
						{isOnceComplete ? DELETE_DIALOG_ONCE : DELETE_DIALOG_ALL}
					</InputLabel>
				</DialogTitle>
				{isOnceComplete ? null : (
					<DialogContent className={classes.contentPadding}>
						{![LATER, NOW, TODAY].includes(selectedRow?.frequency) && (
							<InputLabel className={classes.dialogContent}>{DELETE_SUB_HEADING}</InputLabel>
						)}
						{[LATER, NOW, TODAY].includes(selectedRow?.frequency) &&
							selectedRow?.status === SCHEDULED && (
								<InputLabel className={classes.dialogContent}>{DELETE_ONCE_COMPLETED}</InputLabel>
							)}
						{item?.length && (
							<RadioGroup
								key={item}
								aria-label="delete-group"
								name="delete-group"
								id="delete-group"
								value={deleteType}
								onChange={handleDeleteType}>
								{item?.map((val) => {
									return (
										<FormControlLabel
											key={val}
											id={val}
											className={classes.radio}
											value={val}
											control={
												<Radio
													size="small"
													color="primary"
													classes={{ root: classes.radioButton }}
												/>
											}
											label={val}
										/>
									);
								})}
							</RadioGroup>
						)}
					</DialogContent>
				)}
			</>
		);
	};

	const renderDelete = (param) => {
		switch (param) {
			case FAILED:
			case SCHEDULED:
			case INACTIVE:
				return renderDeleteOptions(deleteOption);
			case COMPLETED:
			case NO_DATA_FOUND:
				return renderDeleteOptions(deleteOptions);
			default:
				return renderDeleteOptions();
		}
	};

	const isOnce = () => {
		return [LATER, NOW, TODAY].includes(selectedRow?.frequency);
	};

	return (
		<Dialog
			id="delete-dialog"
			maxWidth="xs"
			aria-labelledby="confirmation-delete-dialog"
			open={open}
			className={classes.container}>
			<Box style={{ width: isSmallScreen ? 'auto' : 444 }}>
				{renderDelete(isOnce() ? selectedRow?.frequency : selectedRow?.status)}
				<DialogActions className={`${classes.actionBtnPadding}`}>
					<Button onClick={handleCancel} id="cancel" color="primary" className={classes.button}>
						<InputLabel className={classes.buttonLabel}>{CANCEL_BUTTON}</InputLabel>
					</Button>
					<Button
						id="delete"
						disabled={isOnce() ? false : !deleteType}
						autoFocus
						onClick={handleDelete}
						color="primary"
						classes={{ disabled: classes.disabledButton }}
						className={`${classes.button} ${classes.btnDelete}`}>
						<InputLabel className={classes.lblDelete}>{DELETE}</InputLabel>
					</Button>
				</DialogActions>
			</Box>
		</Dialog>
	);
}

export default DeleteDialog;
